import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {EPDSFile} from "../../../models/file-upload";
import {catchError, finalize, tap, throwError} from "rxjs";
import {FileUploadService} from "../../../services/file-upload.service";
import {PartiesService} from "../../../services/parties.service";
import {UtilService} from "../../../services/util.service";
import PlaceResult = google.maps.places.PlaceResult;
import {StateService} from "../../../services/state.service";
import {UserRole} from "../../../models/user";
import {FileUploadComponent} from "../../file-upload/file-upload.component";


@Component({
    selector: 'app-add-intervenor',
    templateUrl: './add-intervenor.component.html',
    styleUrls: ['./add-intervenor.component.scss'],
    standalone: false
})
export class AddIntervenorComponent {
  @ViewChild('fileUpload', { static: false }) fileUpload!: FileUploadComponent;
  protected readonly UserRole = UserRole;
  @Input() a_No = '';
  @Input() emailsWithAccess = '';

  isVisible = false;
  @Input() set visible(visible: boolean) {
    if (!this.isVisible && visible) {
      this.intervenorCompanyName = '';
      this.intervenorEmail = '';
      this.intervenorAddress1 = '';
      this.intervenorAddress2 = '';
      this.intervenorCity = '';
      this.intervenorState = '';
      this.intervenorZipCode = '';
      this.intervenorCountry = '';
      this.intervenorComments = '';
    }

    this.isVisible = visible;
  }

  @Output() onSubmit = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();

  intervenorCompanyName!: string;
  intervenorEmail!: string;
  intervenorAddress1!: string;
  intervenorAddress2!: string;
  intervenorCity!: string;
  intervenorState!: string;
  intervenorZipCode!: string;
  intervenorCountry!: string;
  intervenorComments!: string;

  fileUploadInProgress = false;
  uploadDocMessage = this.fileUploadService.udmPdfExcel;
  requiredFileType = this.fileUploadService.rftPdfExcel;
  attachAssociatedDocOutput = false;
  primaryFiles: EPDSFile[] = [];

  constructor(private util: UtilService,
              private readonly fileUploadService: FileUploadService,
              private readonly partiesService: PartiesService,
              public stateService: StateService) {
  }

  onIntervenorSubmit() {
    if (this.emailsWithAccess.length > 0 && this.emailsWithAccess.includes(this.intervenorEmail)) {
      this.util.displayDialogMessage('Error', this.intervenorEmail + ' already has access to this case.');
      this.onIntervenorCancel();
      return;
    }

    const allFiles = [
      ...this.primaryFiles.map(epdsFile => ( { epdsFile, attachmentType: 'RequestToIntervene' })),
    ];

    console.debug(allFiles);

    this.fileUploadInProgress = true;
    this.fileUploadService.submitFile(allFiles, this.a_No, this.fileUpload)
      .pipe(finalize(() => this.fileUploadInProgress = false))
      .pipe(tap(resp => console.log('Response from submitFile:', resp)),
      catchError(err => {
        // console.error('Error in submitFile:', err);
        return throwError(err);
      })
    ).subscribe(resp => {
      console.debug(resp);
      if (this.intervenorComments)
        this.intervenorComments = this.util.removeCurlyQuotes(this.intervenorComments);
      if (!this.intervenorEmail)
        this.intervenorEmail = this.stateService.user.email;

      this.partiesService.addIntervenor(this.a_No, this.intervenorAddress1!, this.intervenorAddress2!, this.intervenorCity!, this.intervenorState!,
        this.intervenorZipCode!,  this.intervenorCountry!, this.intervenorComments, this.intervenorCompanyName!, this.intervenorEmail!)
        .subscribe((interventorResponse) => {
          console.log(interventorResponse);
          if (interventorResponse.inputErrors) {
            let message = "";
            interventorResponse.inputErrors.forEach(inputErrors =>  message += inputErrors.invalidValue + ": " + inputErrors.message + '<br>');
            this.util.displayDialogMessage("Input Errors", message);
          } else {
            if (interventorResponse.submitNewDocDTO) {
              this.onSubmit.emit();
              this.util.displayDialogMessage('Success', 'You have successfully submitted a request to intervene.').subscribe(() => {});
            } else {
              this.util.displayDialogMessage('Error', 'There was a problem adding the Intervenor.');
            }
          }
      });
    });
  }

  onIntervenorCancel() {
    this.fileUploadInProgress = false;
    this.onCancel.emit();
  }

  onEPDSFileListChange(epdsFileList: EPDSFile[], typeOfList: string): void {
    console.debug("EPDS File list for type %s: %O", typeOfList, epdsFileList);

    if (typeOfList === 'P') {
      this.primaryFiles = epdsFileList;
    }

    console.debug(this.primaryFiles);
  }

  newIntervenorPlaceChanged(place: PlaceResult) {
    let streetAddr = place.formatted_address?.split(",")[0]
    if (place.name !== streetAddr) {
      streetAddr = place.name + "," + streetAddr;
    }
    if (streetAddr) this.intervenorAddress1 = streetAddr;

    place.address_components?.forEach(component => {
      const types = component.types;
      if (types.includes('locality')) {
        this.intervenorCity = component.long_name;
      } else if (types.includes('administrative_area_level_1')) {
        this.intervenorState = component.long_name;
      } else if (types.includes('country')) {
        this.intervenorCountry = component.long_name;
      } else if (types.includes('postal_code')) {
        this.intervenorZipCode = component.long_name;
      }
    });
  }
}
